module.exports = __webpack_public_path__ + "media/images/athletes/1520-02c26b64ab9d39a58b3d07fba91e5d36.png";